import { Message } from "@core/models/message.model";
import { TPagination } from "@custom-types/sorting";
import { createFeatureSelector, createSelector } from "@ngrx/store";

import * as fromMessage from "./message.reducers";

const SELECT_MESSAGE_STATE_SLICE = createFeatureSelector<
  fromMessage.MessageState | undefined
>(fromMessage.MESSAGES_FEATURE_KEY);

// Feature slices are registered lazily, so this slice is undefined until
// its feature module loads - and in tests whenever a spec supplies no
// initial state. Falling back to the reducer's initial state keeps every
// downstream selector reading a real object instead of throwing.
export const SELECT_MESSAGE_STATE = createSelector(
  SELECT_MESSAGE_STATE_SLICE,
  (state: fromMessage.MessageState | undefined): fromMessage.MessageState =>
    state ?? fromMessage.initialState
);

export const SELECT_MESSAGE_LIST = createSelector(
  SELECT_MESSAGE_STATE,
  (state: fromMessage.MessageState): Array<Message> => state.messages
);

export const SELECT_MESSAGE_LOADING_STATUS = createSelector(
  SELECT_MESSAGE_STATE,
  (state: fromMessage.MessageState): boolean => state.loading
);

export const SELECT_MESSAGE_LIST_LENGTH = createSelector(
  SELECT_MESSAGE_STATE,
  (state: fromMessage.MessageState): number => state.messagesLength
);

export const SELECT_MESSAGE_PAGINATION = createSelector(
  SELECT_MESSAGE_STATE,
  (state: fromMessage.MessageState): Partial<TPagination> | undefined =>
    state.pagination
);
